import React from 'react';
import { useFirestoreDocs } from '../hooks/useFirestoreDocs';
import MarkdownRenderer from '../components/MarkdownRenderer';

/**
 * Vista Dinámica de Documentación para Comercios & Tiendas
 */
export default function MerchantDocs() {
  const { docs, loading } = useFirestoreDocs('comercios');

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#64748b', fontWeight: 300 }}>
        Cargando guía para comercios...
      </div>
    );
  }

  return (
    <div className="merchant-docs-container">
      {docs.map((docItem) => (
        <section key={docItem.id} id={docItem.id} className="doc-section" style={{ marginBottom: '2.5rem' }}>
          <MarkdownRenderer content={docItem.contenidoMarkdown} />
        </section>
      ))}
    </div>
  );
}
